export default "/wherehouse_logo_svg.9651970a-fcb3c7.svg?svgr";